import type { FC, MouseEvent } from 'react';
import InputCheckbox from '@components/InputCheckbox';
import clsx from 'clsx';

interface BlockCheckboxProps {
  checked: boolean;
  isVisible: boolean;
  blockId?: string;
  blockName?: string;
  onChange: () => void;
}

const stopEvent = (event: MouseEvent) => {
  event.stopPropagation();
};

export const CheckboxSpacer: FC = () => (
  <div className="pointer-events-none invisible flex items-center pr-1" aria-hidden="true">
    <div className="h-4 w-4 shrink-0" />
  </div>
);

export const BlockCheckbox: FC<BlockCheckboxProps> = ({ checked, isVisible, blockId, blockName, onChange }) => (
  <div
    className={clsx(
      'flex items-center pr-1',
      isVisible
        ? 'opacity-100'
        : 'pointer-events-none opacity-0 transition-opacity duration-150 ease-out group-hover:pointer-events-auto group-hover:opacity-100',
    )}
    data-testid={blockId ? `block-checkbox:${blockId}` : 'block-checkbox'}
    onClick={stopEvent}
  >
    <InputCheckbox
      isChecked={checked}
      onChange={onChange}
      aria-label={blockName ? `Select block ${blockName}` : 'Select block'}
    />
  </div>
);
